export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe5e8c93bedd9f871d897e2bd87c7aa0ec77d5c26&name=fetchTypeahead!'